















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ClearPuzzlePopup from '@/components/popups/ClearPuzzlePopup.vue';
import RevealPuzzlePopup from '@/components/popups/RevealPuzzlePopup.vue';
import CalendarPopup from '@/components/popups/CalendarPopup.vue';
import VictoryPopup from '@/components/popups/VictoryPopup.vue';
import PausePopup from '@/components/popups/PausePopup.vue';
import HelpPopup from '@/components/popups/HelpPopup.vue';
import HintPopup from '@/components/popups/HintPopup.vue';
import ChangeDatePopup from '@/components/popups/ChangeDatePopup.vue';
import { PopupType } from '@/store/module/ui';

const ui = namespace('UI');

@Component({
  components: {
    ClearPuzzlePopup,
    RevealPuzzlePopup,
    VictoryPopup,
    PausePopup,
    CalendarPopup,
    HelpPopup,
    HintPopup,
    ChangeDatePopup
  },
})
export default class PopupLayer extends Vue {
  @ui.State
  public popup!: PopupType | null;
}
